module.exports = __webpack_public_path__ + "img/playlist.0ea7bc9a.svg";